const View = require('public_framework/view')
const fetchCurrentRole = require('public_framework/services/fetch_current_role')

class Attendees extends View {
  constructor () {
    super(...arguments)
    fetchCurrentRole(user => {
      if (user) {
        this.$engageSlackButton().show()
      }
    })
  }

  get els () {
    return {
      $engageSlackButton: '@engage_slack_button'
    }
  }
}

module.exports = Attendees



// WEBPACK FOOTER //
// ./front/apps/public/pages/community_event/javascripts/views/attendees.js